import * as React from "react";
const SvgTrash = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "none", stroke: "currentColor", strokeWidth: 4, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22,14l4,-8h12l4,8 M14,14v44h36v-44 M6,14h52 M32,22v28 M23,22v28 M41,22v28" }));
export default SvgTrash;
